<form #addressForm="ngForm" (submit)="validateAddress($event, addressForm)" appSelectFirstInput>
	<h1 mat-dialog-title>{{modalAddress?.id ? 'Edit' : 'New'}} {{(type ? type : '') | titlecase}}
		{{'addressModalView.addressHeader' | translate}}
	</h1>
	<mat-dialog-content>
		<div fxLayout="column" fxLayoutAlign="start" fxLayoutGap="15px">
			<mat-card *ngIf="warning" class="warning">
				<mat-card-header>{{'addressModalView.warningText' | translate}}</mat-card-header>
				<mat-card-content>
					<p>{{'addressModalView.googlePlacesError' | translate}}</p>
				</mat-card-content>
			</mat-card>
			<div *ngIf="validationResults || noResults" fxLayout="column" fxLayoutAlign="start" fxLayoutGap="15px">
				<mat-card class="warning">
					<h3>{{'addressModalView.addressVerificationHeader' | translate}}</h3>
					<p *ngIf="!addressBookAddress && selectValidAddress && !noResults">
						{{'addressModalView.selectAddressWarning' | translate}}
					</p>
					<p *ngIf="addressBookAddress && !selectValidAddress && !noResults">
						{{'addressModalView.confirmAddressWarning' | translate}}
					</p>
					<p *ngIf="noResults && !requireValidation && user.allowMapValidation">
						{{'addressModalView.cannotValidateAddressWarning1' | translate}}
					</p>
					<p *ngIf="noResults && !requireValidation && !user.allowMapValidation">
						{{'addressModalView.cannotValidateAddressWarning2' | translate}}
					</p>
					<p *ngIf="noResults && requireValidation">
						{{'addressModalView.cannotValidateAddressWarning3' | translate}}
					</p>
				</mat-card>
				<h4>{{'addressModalView.userEnteredLabel' | translate}}:</h4>
				<mat-card class="well">
					<mat-card-content fxLayout="column" fxLayoutAlign="start" fxLayoutGap="15px">
						<div fxLayout="row" fxLayoutAlign="space-between">
							<div>
								<div>
									<p>{{submittedAddress?.address1}}
										{{submittedAddress?.address2?.length > 0 ? ', ' + submittedAddress?.address2 : ''}}</p>
								</div>
								<div><p>{{submittedAddress?.city}}, {{submittedAddress?.state}} {{submittedAddress?.country === 'CA' ? submittedAddress?.postalCode : submittedAddress?.zip}}</p>
								</div>
								<div *ngIf="modalAddress?.phone">
									<p>{{modalAddress?.phone}}</p>
								</div>
							</div>
							<div>
								<button [color]="'primary'" mat-icon-button>
									<mat-icon (click)="editAddress()" *ngIf="!user?.inetUser?.addressBookLocked">edit
									</mat-icon>
								</button>
							</div>
						</div>
						<div *ngIf="modalAddress?.originComments">
							<p><strong>{{'addressModalView.originCommentsLabel' | translate}}:</strong>
								{{modalAddress.originComments}}
							</p>
						</div>
						<div *ngIf="modalAddress?.destComments">
							<p>
								<strong>{{'addressModalView.destinationCommentsLabel' | translate}}:</strong>
								{{modalAddress?.destComments}}
							</p>
						</div>
					</mat-card-content>
				</mat-card>
			</div>
			<div *ngIf="!validationResults && !noResults" fxLayout="column" fxLayoutAlign="start">
				<mat-form-field *ngIf="user?.globalSettings?.enableGooglePlacesSearch && data?.showGooglePlaces">
					<mat-label>{{'addressModalView.searchGooglePlacesPlaceholder' | translate}}</mat-label>
					<input (selectedAddress)="setGoogleAddress($event, addressForm)" [dataToPassThrough]="addressForm"
						   appGoogleSearch
						   id="smartSearch" matInput name="smartSearch" placeholder="Enter a location" type="text"/>
				</mat-form-field>
				<mat-form-field>
					<mat-label>Country</mat-label>
					<mat-select (selectionChange)="setStatesGroup($event?.value, addressForm); clearValidationResults();"
								[(ngModel)]="modalAddress.country" name="country" required>
						<mat-option value="US">{{'addressModalView.countryOptionUsa' | translate}}</mat-option>
						<mat-option value="CA">{{'addressModalView.countryOptionCanada' | translate}}</mat-option>
						<mat-option value="OTHER">{{'addressModalView.countryOptionOther' | translate}}</mat-option>
					</mat-select>
					<mat-error>Country is required</mat-error>
				</mat-form-field>
				<mat-form-field>
					<mat-label>{{'addressModalView.namePlaceholder' | translate}}</mat-label>
					<input #name="ngModel" (ngModelChange)="clearValidationResults()" [(ngModel)]="modalAddress.name"
						   [ngClass]="{'invalid':(name.dirty || addressForm.submitted) && name.errors}"
						   id="name" matInput maxlength="50" name="name" pattern=".*[^ ].*" [required]="true" type="text"/>
					<mat-error>{{'addressModalView.namePlaceholder' | translate}} is required</mat-error>
				</mat-form-field>
				<mat-form-field>
					<mat-label>{{'addressModalView.streetAddressPlaceholder' | translate}}</mat-label>
					<input #address1="ngModel" (ngModelChange)="clearValidationResults()"
						   [(ngModel)]="modalAddress.address1"
						   [ngClass]="{'invalid':(address1.dirty || addressForm.submitted) && address1.errors}"
						   id="address1" matInput maxlength="100" name="address1" pattern=".*[^ ].*" [required]="true"
						   type="text"/>
					<mat-error>{{'addressModalView.streetAddressPlaceholder' | translate}} is required</mat-error>
				</mat-form-field>
				<mat-form-field>
					<mat-label>{{'addressModalView.suitePlaceholder' | translate}}</mat-label>
					<input #address2="ngModel" [(ngModel)]="modalAddress.address2" id="address2" matInput
						   maxlength="100" name="address2" type="text"/>
				</mat-form-field>
				<mat-form-field>
					<mat-label *ngIf="modalAddress.country !== 'OTHER'">{{'addressModalView.cityPlaceholder' | translate}}</mat-label>
					<mat-label *ngIf="modalAddress.country === 'OTHER'">{{'addressModalView.cityOtherCountryLabel' | translate}}</mat-label>
					<input #city="ngModel" (ngModelChange)="clearValidationResults()" [(ngModel)]="modalAddress.city"
						   [ngClass]="{'invalid':(city.dirty || addressForm.submitted) && city.errors}"
						   id="city" matInput maxlength="50" name="city" pattern=".*[^ ].*" [required]="modalAddress.country !== 'OTHER'" type="text"/>
					<mat-error>{{'addressModalView.cityPlaceholder' | translate}} is required</mat-error>
				</mat-form-field>
				<mat-form-field *ngIf="modalAddress.country !== 'OTHER'">
					<mat-label>{{modalAddress.country === 'US' ? 'State' : 'Province'}}</mat-label>
					<mat-select #state="ngModel" (ngModelChange)="clearValidationResults()"
								[(ngModel)]="modalAddress.state"
								[ngClass]="{'invalid':(state.dirty || addressForm.submitted) && state.errors}"
								id="state"
								name="state" [required]="modalAddress.country !== 'OTHER'">
						<mat-option *ngFor='let s of states?.stateProvinces' value="{{s.abbreviation}}">
							{{s.abbreviation}}
						</mat-option>
					</mat-select>
					<mat-error>{{modalAddress.country === 'US' ? 'State' : 'Province'}} is required</mat-error>
				</mat-form-field>
        <mat-form-field *ngIf="modalAddress.country === 'US'">
          <mat-label>{{('addressModalView.zipPlaceholder' | translate)}}</mat-label>
          <input #zip="ngModel" (ngModelChange)="clearValidationResults()" [(ngModel)]="modalAddress.zip"
		  		appZipCodeValidator id="zip" matInput maxlength="5" name="zip"
                type="text"/>
        </mat-form-field>
        <mat-form-field *ngIf="modalAddress.country === 'CA'">
          <mat-label>{{('addressModalView.postalCodePlaceholder'| translate)}}</mat-label>
          <input  #postalCode="ngModel" (ngModelChange)="clearValidationResults()" [(ngModel)]="modalAddress.postalCode"
                  appPostalCodeValidator id="postalCode" matInput maxlength="7" name="postalCode"
                 type="text"/>
        </mat-form-field>
				<mat-form-field *ngIf="modalAddress.country === 'US'">
					<mat-label>{{'addressModalView.plus4Placeholder' | translate}}</mat-label>
					<input #plus4="ngModel" (ngModelChange)="clearValidationResults()" [(ngModel)]="modalAddress.plus4"
						appPlus4Validator id="plus4" matInput maxlength="4"
						name="plus4" type="text"/>
				</mat-form-field>
				<mat-form-field >
					<mat-label>{{'addressModalView.phonePlaceholder' | translate}}</mat-label>
					<input #phone="ngModel" [(ngModel)]="modalAddress.phone" [ngClass]="{'invalid':phone.errors}"
						   [textMask]="{mask: phoneNumberMask(modalAddress.phone, modalAddress.country), guide: false}"
						   appValidatePhone id="phone" matInput maxlength="50" name="phone" type="text"/>
					<mat-error>Please enter a valid phone number</mat-error>
				</mat-form-field>
				<mat-form-field *ngIf="!type">
					<mat-label>{{'addressModalView.originCommentsPlaceholder' | translate}}</mat-label>
					<textarea #destComments="ngModel" [(ngModel)]="modalAddress.originComments" id="originComments"
							  mat-autosize matInput maxlength="1000" name="originComments"></textarea>
				</mat-form-field>
				<mat-form-field *ngIf="!type">
					<mat-label>{{'addressModalView.destinationCommentsPlaceholder' | translate}}</mat-label>
					<textarea #destComments="ngModel" [(ngModel)]="modalAddress.destComments" id="destinationComments"
							  mat-autosize matInput maxlength="1000" name="destinationComments"></textarea>
				</mat-form-field>
				<mat-form-field *ngIf="modalAddress.country === 'OTHER'">
					<mat-label>{{'addressModalView.latitudeLabel' | translate}}</mat-label>
					<input #lat="ngModel" [(ngModel)]="modalAddress.lat" id="lat"
							  mat-autosize matInput maxlength="1000" name="lat" />
				</mat-form-field>
				<mat-form-field *ngIf="modalAddress.country === 'OTHER'">
					<mat-label>{{'addressModalView.longitudeLabel' | translate}}</mat-label>
					<input #lon="ngModel" [(ngModel)]="modalAddress.lon" id="lon"
							  mat-autosize matInput maxlength="1000" name="lon" />
				</mat-form-field>
			</div>
			<div *ngIf="validationResults && addressBookAddress && !selectValidAddress">
				<div class="map-container">
					<ng-template [cdkPortalOutlet]="mapPortal"></ng-template>
				</div>
			</div>
			<div *ngIf="(validationResults && selectValidAddress) || noResults" fxLayout="column" fxLayoutAlign="start"
				 fxLayoutGap="15px">
				<div *ngIf="!showDraggableMap" fxLayout="column" fxLayoutAlign="start" fxLayoutGap="15px">
					<div>
						<h4 *ngIf="!noResults">{{'addressModalView.suggestedAddressLabel' | translate}}:</h4>
						<h4 *ngIf="noResults">{{'addressModalView.noAddressSuggestionsText' | translate}}</h4>
					</div>
					<mat-card *ngIf="validationResults?.length == 0" class="warning">
						<mat-card-content>
							<p>{{'addressModalView.cannotValidateAddressWarning4' | translate}}.</p>
						</mat-card-content>
					</mat-card>
					<mat-radio-group [(ngModel)]="selectedAddress" [color]="'primary'" fxLayout="column"
									 fxLayoutAlign="start"
									 fxLayoutGap="15px" name="selectedAddress">
						<mat-radio-button (change)="setValidatedAddress(modalAddress, a, false)"
										  *ngFor="let a of validationResults"
										  [value]="a.id">
							{{a?.streetAddress1}}{{modalAddress?.address2?.length > 0 ? ', ' +
							modalAddress?.address2 : ''}} <br>
							{{a?.city}}, {{a?.province}} {{a?.postalCode}}
						</mat-radio-button>
						<mat-radio-button (change)="useSubmittedAddress()" *ngIf="!requireValidation"
										  [value]="submittedAddress">
							{{'addressModalView.useEnteredAddressLabel' | translate}}
						</mat-radio-button>
					</mat-radio-group>
				</div>
				<div *ngIf="showDraggableCheckbox && !user?.inetUser?.addressBookLocked">
					<mat-checkbox (change)="initDraggableMap($event.checked)" color="primary">
						{{'addressModalView.setLocationOnMapLabel' | translate}}
					</mat-checkbox>
				</div>
				<div *ngIf="showDraggableMap">
					<div class="map-container">
						<ng-template [cdkPortalOutlet]="mapPortal"></ng-template>
					</div>
				</div>
				<div *ngIf="validationResults && selectValidAddress && !showDraggableMap">
					<div class="map-container">
						<ng-template [cdkPortalOutlet]="mapPortal"></ng-template>
					</div>
				</div>
			</div>
			<mat-card *ngIf="error || (validationResults && !requireValidation && invalidAddress) ||
		(validationResults && validationResults?.length == 0 && requireValidation) || (noResults && requireValidation)"
					  class="danger">
				<mat-card-content>
					<p *ngIf="error">{{'addressModalView.errorProcessingRequestText' | translate}}</p>
					<p *ngIf="validationResults && !requireValidation && invalidAddress">
						{{'addressModalView.addressNotValidatedText' | translate}}
					</p>
					<p *ngIf="validationResults && validationResults?.length == 0 && requireValidation">
						{{'addressModalView.cannotValidateAddressWarning5' | translate}}
					</p>
					<p *ngIf="noResults && requireValidation">
						{{'addressModalView.addressValidationRequiredText' | translate}}
					</p>
				</mat-card-content>
			</mat-card>
		</div>
	</mat-dialog-content>
	<mat-dialog-actions fxLayout="row" fxLayoutAlign="end" fxLayoutGap="5px">
		<button [color]="'accent'" mat-dialog-close mat-raised-button>
			<span>{{'addressModalView.cancelButton' | translate}}</span>
		</button>
		<!-- <button [color]="'primary'" fxLayoutAlign="center center" id="btnSave" mat-raised-button type="submit">
			<span *ngIf="!loading">{{validationResults ? 'Save' : useAddressAsEntered ? 'Save' : 'Validate'}}</span>
			<mat-spinner *ngIf="loading" [diameter]="24"></mat-spinner>
		</button> -->
		<button [color]="'primary'" fxLayoutAlign="center center" id="btnSave" mat-raised-button type="submit">
			<span *ngIf="!loading">
				{{
					(modalAddress?.country === 'OTHER')
					? 'Save'
					: (validationResults ? 'Save' : (useAddressAsEntered ? 'Save' : 'Validate'))
				}}
			</span>
			<mat-spinner *ngIf="loading" [diameter]="24"></mat-spinner>
		</button>
	</mat-dialog-actions>

</form>
